import type { DailyUsage } from '../hooks/useUsage';

export type ServiceStatus = {
  ok: boolean;
  latency_ms: number;
  checks: Record<string, { ok: boolean; detail: string }>;
};

export type SystemStatusResponse = {
  checked_at: string;
  services: Record<string, ServiceStatus>;
};

export function summarizeServices(services: Record<string, ServiceStatus>): {
  rows: { name: string; ok: boolean; latency_ms: number }[];
  okCount: number;
  total: number;
} {
  const rows = Object.entries(services)
    .map(([name, s]) => ({ name, ok: s.ok, latency_ms: s.latency_ms }))
    .sort((a, b) => a.name.localeCompare(b.name));
  return { rows, okCount: rows.filter((r) => r.ok).length, total: rows.length };
}

export function buildUsageBars(daily: DailyUsage[]): number[] {
  if (daily.length === 0) return [];
  const max = Math.max(1, ...daily.map((d) => d.tokens));
  return daily.map((d) => Math.round((d.tokens / max) * 100));
}
